import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = ({ 
  size = "medium", // small, medium, large
  color = "primary", // primary, white, gray
  text = null,
  className = ""
}) => {
  const getSizeClasses = (sizeType) => {
    const sizeMap = {
      small: 'w-4 h-4',
      medium: 'w-8 h-8',
      large: 'w-12 h-12'
    };
    return sizeMap[sizeType] || sizeMap.medium;
  };

  const getColorClasses = (colorType) => {
    const colorMap = {
      primary: 'border-primary-600',
      white: 'border-white',
      gray: 'border-gray-600'
    };
    return colorMap[colorType] || colorMap.primary;
  };

  const sizeClasses = getSizeClasses(size);
  const colorClasses = getColorClasses(color);

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <motion.div
        className={`${sizeClasses} border-4 ${colorClasses} border-t-transparent rounded-full`}
        animate={{ rotate: 360 }}
        transition={{
          duration: 1,
          repeat: Infinity,
          ease: "linear"
        }}
      />
      {text && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className={`mt-3 text-sm ${
            color === 'white' ? 'text-white' : 
            color === 'gray' ? 'text-gray-600' : 
            'text-primary-600'
          }`}
        >
          {text}
        </motion.p>
      )}
    </div>
  );
};

// Full screen loading overlay
export const LoadingOverlay = ({ 
  text = "Loading...", 
  color = "primary",
  className = ""
}) => (
  <div className={`fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50 ${className}`}>
    <LoadingSpinner size="large" color={color} text={text} />
  </div>
);

// Inline loading state
export const InlineLoading = ({ 
  text = "Loading...", 
  color = "primary",
  className = ""
}) => (
  <div className={`flex items-center justify-center py-8 ${className}`}>
    <LoadingSpinner size="medium" color={color} text={text} />
  </div>
);

export default LoadingSpinner;